import { queryClient } from '~system/query/query-client';

const PUBLIC_AUTH_QUERY_KEYS = ['auth-links', 'invite-info'];

export const resetAuthSensitiveQueries = () => {
  queryClient.removeQueries({
    predicate: (query) => {
      return !PUBLIC_AUTH_QUERY_KEYS.includes(String(query.queryKey[0]));
    },
  });
};
